/** Delegated swatch controls also work after filtering replaces the grid. */
(function () {
  'use strict';
  if (window.wsCardSwatchesReady) return;
  window.wsCardSwatchesReady = true;

  function showColorway(card, variantId) {
    var target = card.querySelector('.ws-card__img--colorway[data-variant-id="' + variantId + '"]');
    card.querySelectorAll('.ws-card__img--colorway').forEach(function (img) {
      img.classList.toggle('is-active', img === target);
    });
    var primary = card.querySelector('.ws-card__img--primary');
    if (primary) primary.style.opacity = target ? '0' : '1';
  }

  function reset(card) {
    var active = card.querySelector('.ws-card__swatch--active');
    showColorway(card, active ? active.dataset.variantId : '');
  }

  function preview(event) {
    var swatch = event.target.closest('.ws-card__swatch');
    if (swatch) showColorway(swatch.closest('.ws-card-wrapper'), swatch.dataset.variantId);
  }
  document.addEventListener('mouseover', preview);
  document.addEventListener('focusin', preview);

  document.addEventListener('mouseout', function (event) {
    var card = event.target.closest('.ws-card-wrapper');
    if (!card) return;
    var row = event.target.closest('.ws-card__swatches');
    if (!card.contains(event.relatedTarget) || (row && !row.contains(event.relatedTarget))) reset(card);
  });
  document.addEventListener('focusout', function (event) {
    var card = event.target.closest('.ws-card-wrapper');
    if (card && !card.contains(event.relatedTarget)) reset(card);
  });

  document.addEventListener('click', function (event) {
    var swatch = event.target.closest('.ws-card__swatch');
    if (!swatch) return;
    event.preventDefault();
    var card = swatch.closest('.ws-card-wrapper');
    var variantId = swatch.dataset.variantId;
    card.querySelectorAll('.ws-card__swatch').forEach(function (button) {
      button.classList.toggle('ws-card__swatch--active', button === swatch);
      button.setAttribute('aria-pressed', String(button === swatch));
    });
    showColorway(card, variantId);
    var matchLabel = card.querySelector('.ws-card__match');
    if (matchLabel) matchLabel.textContent = swatch.dataset.colorway + ' · ' + swatch.dataset.variantSku;
    var price = card.querySelector('.ws-card__price');
    if (matchLabel && price && swatch.dataset.cardPrice) price.textContent = swatch.dataset.cardPrice;
    card.querySelectorAll('.ws-card__image-link, .ws-card__title-link, .ws-card__swatch-overflow').forEach(function (link) {
      var url = new URL(link.href, window.location.origin);
      url.searchParams.set('variant', variantId);
      link.href = url.toString();
    });
  });
})();
